import { DatePicker, RadioButton, ReactEasyForm, TextField } from "@aeco-cloud/react-easy-form";
import settings from "@styles/settings";
import { differenceInCalendarMonths, isBefore, isValid } from "date-fns";
import { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { TextContext } from "../../../pages/bepaal-statuut";
import { Label, NavigationButtons, Question, Section } from "../../form-layout";
import StepBody from "../../form-layout/StepBody";
import { SendContext, StateContext } from "../BepaalStatuut";
import { SituationData } from "./Situation";
import lastDayOfQuarter from "date-fns/lastDayOfQuarter";

const Fulltime = () => {
  const send = useContext(SendContext);
  const state = useContext(StateContext);
  const text = useContext(TextContext);
  const form = useForm();

  const secondaryActivityLogic = (data: SubmitData, X: string) => {
    const monthsBefore = differenceInCalendarMonths(data.endDateBreak!, data.startDateBreak!) ?? 0;
    const monthsAfter = parseInt(data?.monthsAfter) ? parseInt(data.monthsAfter) : 0;

    const secondaryTrue = "secondaryActivityTrue";
    const secondaryUndecided = "secondaryActivityUndecided";
    const secondaryFalse = "secondaryActivityFalse";

    const Y = monthsBefore + monthsAfter;
    console.log("Y = ", Y);

    if (data.startDateBreak) {
      if (isBefore(data.startDateBreak, new Date(X))) {
        return secondaryUndecided;
      }
    }

    if (data.monthsBefore === "true") {
      return secondaryUndecided;
    } else if (data.resumeActivity === "false") {
      // resume activity === false means that secondaryUndecided
      // EXCEPT when benefit is false in timeCredit situation -> we know for sure that secondaryFalse
      if (
        data.benefit === "false" &&
        (situation?.type === "timeCreditCare" || situation?.type === "timeCreditTraining")
      ) {
        console.log("False instead of undecided because because of timeCreditException");
        return secondaryFalse;
      }
      console.log("resume Activity is false and no timeCreditException -> undecided");
      return secondaryUndecided;
    } else if (situation?.situation === "civilServant" && situation?.type === "careerBreak") {
      console.log("checked the case: civiliServant + careerBreak");
      if (data?.dependentChildren === "true") {
        return Y < 36 ? secondaryTrue : secondaryFalse;
      } else {
        return Y < 12 ? secondaryTrue : secondaryFalse;
      }
    } else if (situation?.situation === "civilServant" && situation?.type === "thematicLeave") {
      console.log("checked the case: civiliServant + thematicLeave");
      return secondaryFalse;
    } else if (situation?.type === "flemishCareCredit") {
      console.log("checked the case: flemishCareCredit");
      // check if startDateSelfEmployedActivity is 3 months before startDateBreak
      const cond1 =
        differenceInCalendarMonths(data.startDateBreak!, data.startDateSelfEmployedActivity!) >= 3
          ? true
          : false;
      const cond2 = data.benefit === "true" ? true : false;
      console.log(
        "aantal maanden voor start als zelfstandige: ",
        differenceInCalendarMonths(data.startDateBreak!, data.startDateSelfEmployedActivity!)
      );

      // updated logic from mail Annelies on 18/04/2021:
      // Het is dan misschien het gemakkelijkste om de grens van 18maanden te verlagen naar 12 en
      // diegene die boven 12 maar tot 18 zitten door te verwijzen naar de onbeslist pagina.
      // Op die manier kan er navraag gedaan worden over de pensioenopbouw voor die laatste 6 maanden.
      if (cond1 === true && cond2 === true) {
        if (Y >= 18) {
          return secondaryFalse;
        } else if (12 <= Y && Y < 18) {
          return secondaryUndecided;
        } else {
          return secondaryTrue;
        }
      } else {
        return secondaryFalse;
      }
    } else if (situation?.situation === "employee" && situation?.type === "careerBreak") {
      console.log("checked the case: employee + careerBreak");
      return data.benefit === "true" && Y < 12 ? secondaryTrue : secondaryFalse;
    } else if (situation?.situation === "employee" && situation?.type === "thematicLeave") {
      console.log("checked the case: employee + thematicLeave");
      return data.benefit === "true" ? secondaryTrue : secondaryFalse;
    } else if (situation?.type === "timeCreditCare") {
      console.log("checked the case: timeCreditCare");
      const cond1 = data.benefit === "true" ? true : false;
      const cond2 = Y < 51 ? true : false;
      const cond3 =
        differenceInCalendarMonths(new Date(), data.startDateSelfEmployedActivity!) > 12
          ? true
          : false;
      return cond1 && cond2 && cond3 ? secondaryTrue : secondaryFalse;
    } else if (situation?.type === "timeCreditTraining") {
      console.log("checked the case: timeCreditTraining");
      const cond1 = data.benefit === "true" ? true : false;
      const cond2 = Y < 36 ? true : false;
      const cond3 =
        differenceInCalendarMonths(new Date(), data.startDateSelfEmployedActivity!) > 12
          ? true
          : false;
      return cond1 && cond2 && cond3 ? secondaryTrue : secondaryFalse;
    } else {
      console.error("unknown state!");
      return secondaryUndecided;
    }
  };

  const onSubmit: SubmitHandler<any> = (data) => {
    console.log(data);
    const result = secondaryActivityLogic(data, X);
    data.result = result;
    console.log("result: ", result);
    send({ type: "NEXT", data: data });
  };

  const onBack = () => {
    send({ type: "BACK" });
  };

  const situation: SituationData | undefined = state?.context?.memory.situation;
  type SubmitData = {
    startDateSelfEmployedActivity: Date | null;
    startDateBreak: Date | null;
    endDateBreak: Date | null;
    dependentChildren: "true" | "false" | "";
    monthsBefore: string;
    monthsAfter: string;
    benefit: "true" | "false" | "";
    resumeActivity: "true" | "false" | "";
  };

  let X = "1/1/2012";
  if (situation?.type === "timeCreditCare" || situation?.type === "timeCreditTraining") {
    X = "1/1/2017";
  }
  // console.log("X date: ", new Date(X));

  // we show the next steps if monthsBefore is False
  // but in the case of thematicLeave+employee, the monthsBeforequestion is not shown, so in this case we also show the
  // next steps
  const showNextSteps =
    form.watch("monthsBefore") === "false"
      ? true
      : situation?.type === "thematicLeave" && situation?.situation === "employee";

  const year = state?.context?.memory.quarter?.quarterYear;
  const quarter = state?.context?.memory.quarter?.quarterNumber;

  let quarterStart = new Date();
  if (year && quarter) {
    quarterStart = new Date(year, (quarter - 1) * 3, 1);
  }
  const quarterEnd = lastDayOfQuarter(quarterStart)
  console.log("quarter: ", quarter)
  console.log("quarterStart: ", quarterStart)
  console.log("quarterEnd: ", quarterEnd)

  return (
    <ReactEasyForm form={form}>
      <StepBody>
        <Section>
          <Question
            showIf={!(situation?.type === "thematicLeave" && situation?.situation === "employee")}
          >
            <Label label={"Heb je jouw loopbaan al eens onderbroken voor " + X + "?"} />
            <RadioButton
              name="monthsBefore"
              minButtonWidth="240px"
              {...settings.selectButtonsProps}
              options={[
                { value: "true", label: text.general_yes },
                { value: "false", label: text.general_no },
              ]}
              rules={{
                required: text.general_requiredQuestion,
              }}
            />
          </Question>
          <>
            {showNextSteps && (
              <>
                {" "}
                <Question
                  showIf={["flemishCareCredit", "timeCreditCare", "timeCreditTraining"].includes(
                    situation?.type
                  )}
                >
                  <Label label={text.careerBreak_startDateSelfEmployedActivity_label} />
                  <DatePicker
                    name="startDateSelfEmployedActivity"
                    rules={{
                      required: text.general_requiredQuestion,
                      validate: {
                        couldNotBeParsed: (value: any) =>
                          isValid(value) || text.general_dateNotValid,
                      },
                    }}
                    muiKeyBoardDatePickerProps={{ fullWidth: true, inputVariant: "outlined" }}
                  />
                </Question>
                <Question showIf={situation?.type !== "thematicLeave"}>
                  <Label label={text.careerBreak_startDateBreak_label} />
                  <DatePicker
                    name="startDateBreak"
                    rules={{
                      required: text.general_requiredQuestion,
                      validate: {
                        couldNotBeParsed: (value: any) =>
                          isValid(value) || text.general_dateNotValid,
                      },
                    }}
                    muiKeyBoardDatePickerProps={{ fullWidth: true, inputVariant: "outlined" }}
                  />
                </Question>
                <Question showIf={situation?.type !== "thematicLeave"}>
                  <Label label={text.careerBreak_endDateBreak_label} />
                  <DatePicker
                    name="endDateBreak"
                    rules={{
                      required: text.general_requiredQuestion,
                      validate: {
                        couldNotBeParsed: (value: any) =>
                          isValid(value) || text.general_dateNotValid,
                      },
                    }}
                    muiKeyBoardDatePickerProps={{ fullWidth: true, inputVariant: "outlined" }}
                  />
                </Question>
                <Question
                  showIf={
                    situation?.type !== "thematicLeave" &&
                    isBefore(form.watch("endDateBreak"), quarterEnd)
                  }
                >
                  <Label label={text.careerBreak_resumeActivity_label} />
                  <RadioButton
                    name="resumeActivity"
                    minButtonWidth="240px"
                    {...settings.selectButtonsProps}
                    options={[
                      { value: "true", label: text.general_yes },
                      { value: "false", label: text.general_no },
                    ]}
                    rules={{
                      required: text.general_requiredQuestion,
                    }}
                  />
                </Question>
                <Question
                  showIf={
                    situation?.situation === "civilServant" && situation?.type === "careerBreak"
                  }
                >
                  <Label label={text.careerBreak_dependentChildren_label} />
                  <RadioButton
                    name="dependentChildren"
                    minButtonWidth="240px"
                    {...settings.selectButtonsProps}
                    options={[
                      { value: "true", label: text.general_yes },
                      { value: "false", label: text.general_no },
                    ]}
                    rules={{
                      required: text.general_requiredQuestion,
                    }}
                  />
                </Question>
                <Question
                  showIf={
                    !(situation?.type === "thematicLeave" && situation?.situation === "employee")
                  }
                >
                  <Label label={text.careerBreak_monthsAfter_label} />
                  <TextField
                    name="monthsAfter"
                    muiTextFieldProps={{ variant: "outlined", fullWidth: true, type: "number" }}
                    rules={{
                      required: text.general_requiredQuestion,
                    }}
                  />
                </Question>
                <Question
                  showIf={
                    [
                      "flemishCareCredit",
                      "thematicLeave",
                      "timeCreditCare",
                      "timeCreditTraining",
                    ].includes(situation?.type) ||
                    (situation?.situation === "employee" && situation?.type === "careerBreak")
                  }
                >
                  <Label label={text.careerBreak_benefit_label} />
                  <RadioButton
                    name="benefit"
                    minButtonWidth="240px"
                    {...settings.selectButtonsProps}
                    options={[
                      { value: "true", label: text.general_yes },
                      { value: "false", label: text.general_no },
                    ]}
                    rules={{
                      required: text.general_requiredQuestion,
                    }}
                  />
                </Question>
              </>
            )}
          </>
        </Section>
      </StepBody>
      <NavigationButtons onBack={onBack} onNext={form.handleSubmit(onSubmit)} />
    </ReactEasyForm>
  );
};
export default Fulltime;
